module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_8023.f3cd34cd.png";